import { render, staticRenderFns } from "./UniAwemeSelect.vue?vue&type=template&id=14d55a59"
import script from "./UniAwemeSelect.vue?vue&type=script&lang=js"
export * from "./UniAwemeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports